export const BACKEND_URL = '/backend/api/';
